import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { id: '', label: 'Home' },
    { id: 'about', label: 'About Us' },
    { id: 'packages', label: 'Tour Packages' },
    { id: 'destinations', label: 'Destinations' },
    { id: 'testimonials', label: 'Testimonials' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <nav className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-md border-b border-sky-200 text-gray-900 shadow-lg transition-all duration-300">
      <div className="flex items-center justify-between px-4 sm:px-6 lg:px-12 py-3">
        {/* Logo & Brand */}
        <a
          href="#"
          className="flex items-center gap-3 hover:scale-105 transition-transform duration-200"
        >
          <div>
                <img 
                  src="/travelrmania.png" 
                  alt="Travelrmania Logo" 
                  className="w-12 h-12 rounded-full ring-2 ring-cyan-500"
                />
          </div>

          <div className="hidden sm:block">
            <h1 className="text-xl lg:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 via-blue-600 to-cyan-500">Travelrmania</h1>
            <p className="text-xs text-sky-600">Your Journey, Our Passion</p>
          </div>
        </a>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex space-x-6 text-sm font-medium">
          {navLinks.map(({ id, label }) => (
            <a
              key={id}
              href={`#${id}`}
              className="relative group transition duration-300 text-gray-700 hover:text-cyan-600 py-2"
            >
              {label}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-sky-500 to-cyan-500 group-hover:w-full transition-all duration-300 rounded-full"></span>
            </a>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="hidden lg:flex items-center space-x-3">
          <a
            href="tel:+918929550611"
            className="flex items-center gap-2 bg-gradient-to-r from-sky-500 to-blue-600 text-white px-4 py-2 text-sm font-semibold rounded-full shadow-lg hover:from-sky-600 hover:to-blue-700 hover:scale-105 hover:shadow-xl transition-all"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            Call Now
          </a>
          <a
            href="https://wa.me/918929550611"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-4 py-2 text-sm font-semibold rounded-full shadow-lg hover:scale-105 transition-all"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            WhatsApp
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          {menuOpen ? (
            <X size={28} className="text-cyan-600" />
          ) : (
            <Menu size={28} className="text-gray-700" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden transition-all duration-300 ease-in-out overflow-hidden ${
          menuOpen ? 'max-h-[600px] py-4' : 'max-h-0'
        } bg-gradient-to-br from-sky-50 to-cyan-50 border-t border-sky-200`}
      >
        <div className="flex flex-col items-center gap-4 px-4">
          {navLinks.map(({ id, label }) => (
            <a
              key={id}
              href={`#${id}`}
              onClick={() => setMenuOpen(false)}
              className="text-base font-medium text-gray-700 hover:text-cyan-600 transition w-full text-center py-2 rounded-lg hover:bg-white/50"
            >
              {label}
            </a>
          ))}
          
          <div className="w-full border-t border-sky-200 my-2"></div>
          
          <a
            href="tel:+918929550611"
            className="w-fit flex items-center gap-2 bg-gradient-to-r from-sky-500 to-blue-600 text-white px-6 py-2.5 font-semibold rounded-full shadow-lg hover:from-sky-600 hover:to-blue-700 hover:scale-105 transition-all"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            Call Now
          </a>
          
          <a
            href="https://wa.me/918929550611"
            target="_blank"
            rel="noopener noreferrer"
            className="w-fit flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-6 py-2.5 font-semibold rounded-full shadow-lg hover:scale-105 transition-all"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            WhatsApp Us
          </a>

          <div className="text-xs text-sky-600 text-center mt-2">
            📞 +91-89295-50611<br />
            ⏰ Available 24/7
          </div>
        </div>
      </div>
    </nav>
  );
}

// import React, { useState } from 'react';
// import { Menu, X } from 'lucide-react';

// export default function Navbar() {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const navLinks = [
//     { id: '', label: 'Home' },
//     { id: 'about', label: 'About Us' },
//     { id: 'packages', label: 'Tour Packages' },
//     { id: 'destinations', label: 'Destinations' },
//     { id: 'testimonials', label: 'Testimonials' },
//     { id: 'contact', label: 'Contact' },
//   ];

//   return (
//     <nav className="sticky top-0 z-50 w-full bg-gradient-to-r from-gray-900 via-blue-900 to-gray-900 text-white shadow-lg transition-all duration-300">
//       <div className="flex items-center justify-between px-4 sm:px-6 lg:px-12 py-3">
//         {/* Logo & Brand */}
//         <a
//           href="#"
//           className="flex items-center gap-3 hover:scale-105 transition-transform duration-200"
//         >
//           <div>
//                 <img 
//                   src="/travelrmania.png" 
//                   alt="Travelrmania Logo" 
//                   className="w-12 h-12 rounded-full ring-2 ring-orange-500"
//                 />
//           </div>

//           <div className="hidden sm:block">
//             <h1 className="text-xl lg:text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-blue-300 to-orange-400">Travelrmania</h1>
//             <p className="text-xs text-blue-300">Your Journey, Our Passion</p>
//           </div>
//         </a>

//         {/* Desktop Navigation */}
//         <div className="hidden lg:flex space-x-6 text-sm font-medium">
//           {navLinks.map(({ id, label }) => (
//             <a
//               key={id}
//               href={`#${id}`}
//               className="relative group transition duration-300 hover:text-orange-400 py-2"
//             >
//               {label}
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 group-hover:w-full transition-all duration-300 rounded-full"></span>
//             </a>
//           ))}
//         </div>

//         {/* Action Buttons */}
//         <div className="hidden lg:flex items-center space-x-3">
//           <a
//             href="tel:+918929550611"
//             className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 text-sm font-semibold rounded-full shadow-lg hover:bg-blue-600 hover:scale-105 hover:shadow-xl transition-transform"
//           >
//             <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//               <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//             </svg>
//             Call Now
//           </a>
//           <a
//             href="https://wa.me/918929550611"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 text-sm font-semibold rounded-full shadow-lg hover:scale-105 transition-transform"
//           >
//             <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
//               <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//             </svg>
//             WhatsApp
//           </a>
//         </div>

//         {/* Mobile Menu Button */}
//         <button
//           className="lg:hidden focus:outline-none"
//           onClick={() => setMenuOpen(!menuOpen)}
//           aria-label={menuOpen ? 'Close menu' : 'Open menu'}
//         >
//           {menuOpen ? (
//             <X size={28} className="text-orange-400" />
//           ) : (
//             <Menu size={28} className="text-white" />
//           )}
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       <div
//         className={`lg:hidden transition-all duration-300 ease-in-out overflow-hidden ${
//           menuOpen ? 'max-h-[600px] py-4' : 'max-h-0'
//         } bg-gradient-to-r from-gray-800 via-blue-900 to-gray-800`}
//       >
//         <div className="flex flex-col items-center gap-4 px-4">
//           {navLinks.map(({ id, label }) => (
//             <a
//               key={id}
//               href={`#${id}`}
//               onClick={() => setMenuOpen(false)}
//               className="text-base font-medium text-white hover:text-orange-400 transition w-full text-center py-2 rounded-lg hover:bg-white/10"
//             >
//               {label}
//             </a>
//           ))}
          
//           <div className="w-full border-t border-white/20 my-2"></div>
          
//           <a
//             href="tel:+918929550611"
//             className="w-fit flex items-center gap-2 bg-blue-500 text-white px-6 py-2.5 font-semibold rounded-full shadow-lg hover:bg-blue-600 hover:scale-105 transition-transform"
//           >
//             <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//               <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//             </svg>
//             Call Now
//           </a>
          
//           <a
//             href="https://wa.me/918929550611"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="w-fit flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-6 py-2.5 font-semibold rounded-full shadow-lg hover:scale-105 transition-transform"
//           >
//             <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
//               <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//             </svg>
//             WhatsApp Us
//           </a>

//           <div className="text-xs text-blue-300 text-center mt-2">
//             📞 +91-89295-50611<br />
//             ⏰ Available 24/7
//           </div>
//         </div>
//       </div>
//     </nav>
//   );
// }

// import React, { useState } from 'react';
// import { Menu, X } from 'lucide-react';

// export default function Navbar() {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const navLinks = [
//     { id: '', label: 'Home' },
//     { id: 'about', label: 'About Us' },
//     { id: 'packages', label: 'Tour Packages' },
//     { id: 'vehicles', label: 'Our Fleet' },
//     { id: 'destinations', label: 'Destinations' },
//     { id: 'testimonials', label: 'Testimonials' },
//     { id: 'contact', label: 'Contact' },
//   ];

//   return (
//     <nav className="sticky top-0 z-50 w-full bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 text-white shadow-lg transition-all duration-300">
//       <div className="flex items-center justify-between px-4 sm:px-6 lg:px-12 py-3">
//         {/* Logo & Brand */}
//         <a
//           href="#"
//           className="flex items-center gap-3 hover:scale-105 transition-transform duration-200"
//         >
// <div className="bg-white p-2 rounded-full shadow-lg">
//   <svg
//     className="w-8 h-8 text-blue-600"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     viewBox="0 0 24 24"
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       d="M10.5 21l3-7.5L21 10.5l-7.5-3L10.5 0 9 7.5 1.5 10.5l7.5 3L10.5 21z"
//     />
//   </svg>
// </div>

//           <div className="hidden sm:block">
//             <h1 className="text-xl lg:text-2xl font-bold tracking-tight">Dream to Travels</h1>
//             <p className="text-xs text-white/80">Your Journey, Our Passion</p>
//           </div>
//         </a>

//         {/* Desktop Navigation */}
//         <div className="hidden lg:flex space-x-6 text-sm font-medium">
//           {navLinks.map(({ id, label }) => (
//             <a
//               key={id}
//               href={`#${id}`}
//               className="relative group transition duration-300 hover:text-yellow-300 py-2"
//             >
//               {label}
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-300 group-hover:w-full transition-all duration-300 rounded-full"></span>
//             </a>
//           ))}
//         </div>

//         {/* Action Buttons */}
//         <div className="hidden lg:flex items-center space-x-3">
//           <a
//             href="tel:+917027005176"
//             className="flex items-center gap-2 bg-white text-purple-600 px-4 py-2 text-sm font-semibold rounded-full shadow-lg hover:scale-105 hover:shadow-xl transition-transform"
//           >
//             <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//               <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//             </svg>
//             Call Now
//           </a>
//           <a
//             href="https://wa.me/917027005176"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 text-sm font-semibold rounded-full shadow-lg hover:scale-105 transition-transform"
//           >
//             <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
//               <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//             </svg>
//             WhatsApp
//           </a>
//         </div>

//         {/* Mobile Menu Button */}
//         <button
//           className="lg:hidden focus:outline-none"
//           onClick={() => setMenuOpen(!menuOpen)}
//           aria-label={menuOpen ? 'Close menu' : 'Open menu'}
//         >
//           {menuOpen ? (
//             <X size={28} className="text-yellow-300" />
//           ) : (
//             <Menu size={28} className="text-white" />
//           )}
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       <div
//         className={`lg:hidden transition-all duration-300 ease-in-out overflow-hidden ${
//           menuOpen ? 'max-h-[600px] py-4' : 'max-h-0'
//         } bg-gradient-to-r from-blue-700 via-purple-700 to-pink-700`}
//       >
//         <div className="flex flex-col items-center gap-4 px-4">
//           {navLinks.map(({ id, label }) => (
//             <a
//               key={id}
//               href={`#${id}`}
//               onClick={() => setMenuOpen(false)}
//               className="text-base font-medium text-white hover:text-yellow-300 transition w-full text-center py-2 rounded-lg hover:bg-white/10"
//             >
//               {label}
//             </a>
//           ))}
          
//           <div className="w-full border-t border-white/20 my-2"></div>
          
//           <a
//             href="tel:+917027005176"
//             className="w-fit flex items-center gap-2 bg-white text-purple-600 px-6 py-2.5 font-semibold rounded-full shadow-lg hover:scale-105 transition-transform"
//           >
//             <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//               <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//             </svg>
//             Call Now
//           </a>
          
//           <a
//             href="https://wa.me/917027005176"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="w-fit flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-2.5 font-semibold rounded-full shadow-lg hover:scale-105 transition-transform"
//           >
//             <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
//               <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//             </svg>
//             WhatsApp Us
//           </a>

//           <div className="text-xs text-white/70 text-center mt-2">
//             📞 +91-7027005176 | +91-7082127844<br />
//             ⏰ Available 24/7
//           </div>
//         </div>
//       </div>
//     </nav>
//   );
// }

// import React, { useState } from 'react';
// import { Menu, X } from 'lucide-react';
// import logo from '../assets/logo.png';

// export default function Navbar() {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const navLinks = [
//     { id: '', label: 'Home' },
//     { id: 'about', label: 'About' },
//     { id: 'skills', label: 'Skills' },
//     { id: 'projects', label: 'Projects' },
//     { id: 'experience', label: 'Experience' },
//     { id: 'youtube', label: 'Videos' },
//     { id: 'contact', label: 'Contact' },
//   ];

//   return (
//     <nav className="sticky top-0 z-50 w-full bg-gray-900 text-white shadow-md transition-all duration-300">
//       <div className="flex items-center justify-between px-4 sm:px-6 py-3">
//         {/* Logo */}
//         <a
//           href="#hero"
//           className="flex items-center gap-2 hover:scale-105 transition-transform duration-200"
//         >
//           <img
//             src={logo}
//             alt="Logo"
//             className="h-10 w-10 object-contain rounded-full shadow-md"
//           />
//         </a>

//         {/* Desktop Navigation */}
//         <div className="hidden md:flex space-x-4 lg:space-x-6 text-sm lg:text-base font-medium">
//           {navLinks.map(({ id, label }) => (
//             <a
//               key={id}
//               href={`#${id}`}
//               className="relative group transition duration-300 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500"
//             >
//               {label}
//               <span className="block h-0.5 max-w-0 group-hover:max-w-full transition-all duration-300 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 rounded-full"></span>
//             </a>
//           ))}
//         </div>

//         {/* Buttons */}
//         <div className="hidden md:flex items-center space-x-3">
//           <a
//             href="https://www.youtube.com/@Sadabahar-iu2rr"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="bg-gradient-to-r from-red-500 to-yellow-500 text-white px-4 py-1.5 text-sm rounded-full shadow hover:scale-105 transition-transform"
//           >
//             My YouTube
//           </a>
//           <a
//             href="/Jagdish_Singh_CV.pdf"
//             download
//             className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 py-1.5 text-sm rounded-full shadow hover:scale-105 transition-transform"
//           >
//             Download CV
//           </a>
//         </div>

//         {/* Mobile Menu Button */}
//         <button
//           className="md:hidden focus:outline-none"
//           onClick={() => setMenuOpen(!menuOpen)}
//           aria-label={menuOpen ? 'Close menu' : 'Open menu'}
//         >
//           {menuOpen ? (
//             <X size={28} className="text-pink-400" />
//           ) : (
//             <Menu size={28} className="text-gradient bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500" />
//           )}
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       <div
//         className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
//           menuOpen ? 'max-h-[500px] py-4' : 'max-h-0'
//         } bg-gray-900/95`}
//       >
//         <div className="flex flex-col items-center gap-4 px-4">
//           {navLinks.map(({ id, label }) => (
//             <a
//               key={id}
//               href={`#${id}`}
//               onClick={() => setMenuOpen(false)}
//               className="text-base font-medium text-gray-100 hover:text-pink-400 transition"
//             >
//               {label}
//             </a>
//           ))}
//           <a
//             href="https://www.youtube.com/@Sadabahar-iu2rr"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="w-fit bg-gradient-to-r from-red-500 to-yellow-500 text-white px-5 py-2 rounded-full shadow hover:scale-105 transition-transform"
//           >
//             My YouTube
//           </a>
//           <a
//             href="/Jagdish_Singh_CV.pdf"
//             download
//             className="w-fit bg-gradient-to-r from-blue-500 to-purple-600 text-white px-5 py-2 rounded-full shadow hover:scale-105 transition-transform"
//           >
//             Download CV
//           </a>
//         </div>
//       </div>

//     </nav>
//   );
// }

